<script setup lang="ts">
import { validateEmail } from '~/utils/common'

const visibleValue = defineModel<boolean>('visible')
const { t } = useI18n()
const form = ref({
  name: '',
  phone: '',
  email: '',
  desc: '',
  funcId: '',
})
const rules = computed(() => {
  return {
    name: [
      {
        required: true,
        message: t('请填写此字段'),
      },
    ],
    phone: [
      {
        validator: (value: string, cb: any) => {
          if (value && !/^9\d{8}$/.test(value)) {
            cb(t('请输入有效的手机号'))
          }
        },
      },
    ],
    email: [
      {
        required: true,
        message: t('请填写此字段'),
      },
      {
        validator: (value: string, cb: any) => {
          if (!validateEmail(value)) {
            cb(t('请输入有效的邮箱'))
          }
          else {
            cb()
          }
        },
      },
    ],
    funcId: [
      {
        required: true,
        message: t('请选择一个话题'),
      },
    ],
    desc: [
      {
        required: true,
        message: t('请填写此字段'),
      },
    ],
  }
})
// const rules =
const loading = ref(false)
const formRef = ref()
const { $request } = useNuxtApp()
const funcOptions = computed(() => {
  return [{
    label: t('产品功能'),
    value: 0,
  }, {
    label: t('会员开通'),
    value: 1,
  }, {
    label: t('合作咨询'),
    value: 2,
  }, {
    label: t('数据问题'),
    value: 3,
  }, {
    label: t('技术支持'),
    value: 4,
  }, {
    label: t('其他问题'),
    value: 5,
  }]
})

async function handleSubmit() {
  formRef.value?.validate(async (valid: boolean) => {
    if (valid) {
      return
    }
    try {
      loading.value = true
      await $request('/br/forms', {
        body: {
          ...form.value,
          formType: 1,
        },
        method: 'POST',
      })
      Message.success(t(`感谢您的提交，我们已收到您的问题，将尽快通过您提供的联系方式与您联系并进行答复。`))
      loading.value = false
      handleCancel()
    }
    catch {
      // console.error('提交表单时发生错误:', error)
      loading.value = false
    }
  })
}
function handleCancel() {
  formRef.value?.clearValidate()
  formRef.value?.resetFields()
  visibleValue.value = false
}
</script>

<template>
  <a-modal
    :visible="visibleValue"
    hide-title
    :width="800"
    :footer="false"
    modal-class="pt-contact-dialog"
  >
    <div class="text-18 text-[--color-text-1] font-700 lh-26">
      {{ $t('联系我们') }}
      <i class="icon-shanchu absolute right-16 top-16 cursor-pointer text-16 color-[--color-text-3] hover:color-[--color-text-1]" @click="handleCancel" />
    </div>
    <div class="pt-8 text-14 text-[--color-text-3] lh-22">
      {{ $t('请填写以下信息，我们的客服团队将根据您提供的联系方式，通过邮箱或电话与您取得联系。') }}
    </div>
    <a-form ref="formRef" :model="form" :rules="rules" class="pt-14">
      <a-row>
        <a-col :span="24">
          <a-form-item field="name" :label="$t('姓名')" class="pt-contact-dialog__form-item">
            <a-input v-model="form.name" size="large" :placeholder="$t('姓名')" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item field="email" :label="$t('邮箱')" class="pt-contact-dialog__form-item">
            <a-input v-model="form.email" size="large" :placeholder="$t('邮箱')" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item field="phone" :label="$t('电话')" class="pt-contact-dialog__form-item">
            <a-input v-model="form.phone" size="large" :placeholder="$t('电话')" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="24">
          <a-form-item field="funcId" :label="$t('关于')" class="pt-contact-dialog__form-item">
            <a-select v-model="form.funcId" :placeholder="$t('请选择一个话题')">
              <a-option v-for="option in funcOptions" :key="option.value" :value="option.value">
                {{ option.label }}
              </a-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="24">
          <a-form-item :label="$t('问题描述')" class="pt-contact-dialog__form-item" field="desc">
            <a-textarea
              v-model="form.desc" size="large"
              :auto-size="{
                minRows: 4,
              }" :placeholder="$t('请简单描述您的问题')"
            />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <div class="mt-14 flex justify-end gap-8">
      <a-button type="primary" :loading="loading" size="large" @click="handleSubmit">
        {{ $t('发送') }}
      </a-button>
      <a-button type="outline" class="b-[--color-border-2]! text-[--color-text-1]! hover:opacity-70" size="large" @click="handleCancel">
        {{ $t('取消') }}
      </a-button>
    </div>
  </a-modal>
</template>

<style lang="less">
.pt-contact-dialog {
  &.arco-modal {
    @apply 'rounded-16';
  }
  .arco-modal-body {
    @apply 'p-24';
  }
  &__form-item {
    flex-direction: column;
    @apply 'py-10';
    position: relative;
    .arco-col{
      width: 100%;
    }
    .arco-form-item-label-col {
      justify-content: flex-start;
      @apply 'leading-22 text-[--color-text-1] font-500 mb-8';
    }
    .arco-form-item-message {
      // display: none;
      position: absolute;
      @apply '-bottom-10';
      left: 0;
    }
    .arco-input-wrapper .arco-input.arco-input-size-large {
      @apply 'py-8';
    }
    .arco-select-view-single.arco-select-view-size-medium .arco-select-view-input, .arco-select-view-single.arco-select-view-size-medium .arco-select-view-value {
      @apply 'py-8';
    }

  }
  .arco-btn-size-large{
    @apply 'px-20 h-40';
  }
}
</style>
